import React from "react";

export interface CommentIconProps {
    width?: number;
    height?: number;
}

export const CommentIcon = ({ width = 16, height = 17 }: CommentIconProps = {}): JSX.Element => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 17" fill="none" aria-label="Comment Icon" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M3 0C1.34315 0 0 1.34315 0 3V11C0 12.4259 0.99485 13.6195 2.32833 13.9245V18.009L7.14062 14H15C16.6569 14 18 12.6569 18 11V3C18 1.34315 16.6569 0 15 0H3Z" fill="#1379CE"/>
        </svg>

    );
};